<template>
  <div>
    <v-progress-linear v-if="$apollo.loading" indeterminate />
    <v-row v-else>
      <v-col>
        <metric-card label="No Support Owner" :total="subscriptions.edges.length" />

        <vue-json-to-csv :json-data="dataString" :csv-title="`${$moment().format('YYYY_MM_DD')}_no_support_owner`">
          <v-btn class="mt-2">
            Download CSV
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { SUBSCRIPTION_QUERY } from "@/graphql/queries/subscriptions";
import VueJsonToCsv from "vue-json-to-csv";
import MetricCard from "@/components/shared/MetricCard";

export default {
  name: "ClientsWithoutSupportOwner",
  components: {
    MetricCard,
    VueJsonToCsv,
  },
  data() {
    return {
      subscriptions: [],
      loadingCSV: false,
      dataString: "",
    };
  },

  apollo: {
    subscriptions: {
      query: SUBSCRIPTION_QUERY,
      variables() {
        return {
          active: true,
          supportOwnerId_Isnull: true,
        };
      },
      update(data) {
        this.dataString = data.userSubscriptions.edges.map((item) => {
          return {
            firstName: item.node.user.firstName,
            lastName: item.node.user.lastName,
            email: item.node.user.email,
            phone: item.node.user.userProfile.phone,
            country: item.node.user.userProfile.country?.code,
            startDate: item.node.startDate,
          };
        });
        return data.userSubscriptions;
      },
    },
  },
};
</script>
